import API from '@/api/index';

const dtMapping = {
  actions: {
    getDtMapping ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.dtMapping
          .getDtMapping(data)
          .then(response => {
            if (response.data) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    createDtMapping ({ state }, data) {
      return new Promise((resolve, reject) => {
        API.dtMapping.createDtMapping(data).then(response => {
          if (response.data) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        }).catch(error => {
          reject(error);
        });
      });
    },
  }
};

export default dtMapping;



// WEBPACK FOOTER //
// ./src/store/modules/dtMapping.js